import {useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import axios from 'axios';

const Login = () => {

    const [password, setPassword] = useState();
    const [email, setEmail] = useState();

    const history = useHistory();

    axios.defaults.withCredentials = true;
    const handleLogin = (e) => {
        e.preventDefault();
        axios.post('http://localhost:8000/loginUser', {email, password})
        .then(res => {
            console.log(res)
            if(res.data.Login){
                history.push('/dashboard')
                history.push('/')
            }else{
              history.push('/')
            }
        })
        .then(err => console.log(err))
    }
    
    return (
        <>
            <div className="home">
				<nav>
					<ul>
              <li><a href="/">Movie Home</a></li>
                        
					</ul>
				</nav>
			</div>
            
            <div className="auth">
                <h2>Login Here!</h2>
                <br/>
                <form onSubmit={handleLogin}>
                    <label>Email:</label><br/>
                    <input type="text" name="email" 
                    placeholder="Enter Email"
                    autoComplete="off"
                    onChange={(e) => setEmail(e.target.value)}
                    /><br/>
                    <label>Password:</label><br/>
                    <input type="password" name="password" 
                    placeholder="Enter Password"
                    autoComplete = "off"
                    onChange={(e) => setPassword(e.target.value)}
                    />
                    <br/><br/>
                    <button type="submit">Login</button><br/><br/>
                    <p>Don't have an Account?</p>
                    <Link to="/register" id="link">Register</Link>
                    <br/><br/>
                </form>
            </div>
        </>
    )
}

export default Login;